export const PACKAGING_DRAFT_STATUS_MESSAGE =
  "A draft cannot change status. Publish the packaging by saving it. Status can be changed only after it is no longer a draft."

export const PACKAGING_LIST_FORBIDDEN_MESSAGE =
  "You don't have access to the packaging list. Ask an admin for the products permission."

export const PACKAGING_WRITE_FORBIDDEN_MESSAGE =
  "You don't have access to save packaging. Ask an admin for the EPR reports permission."

export function packagingPermissionMessage(error, kind = "list") {
  const status = Number(error?.status)
  const text = String(error?.message ?? "")
  const forbidden =
    status === 403 || /\b403\b|forbidden|permission denied/i.test(text)
  if (!forbidden) return null
  return kind === "write"
    ? PACKAGING_WRITE_FORBIDDEN_MESSAGE
    : PACKAGING_LIST_FORBIDDEN_MESSAGE
}
